import * as actions from './karmaActivity.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { KarmaActivityModel } from '@smarttask-common/src/lib/models/Karma/Activity/KarmaActivitiyModel';

export const karmaActivityAdapter = createEntityAdapter<KarmaActivityModel>({
    selectId: (x) => x.activity_id,
});
export interface karmaActivityState extends EntityState<KarmaActivityModel> {}

export const initialState: karmaActivityState = karmaActivityAdapter.getInitialState({});

export function karmaActivityReducers(state: karmaActivityState = initialState, action: actions.karmaActivityActions) {
    switch (action.type) {
        case actions.karmaActivityActionTypes.ADD_ACTIVITY:
            return karmaActivityAdapter.addOne(action.activity, state);

        case actions.karmaActivityActionTypes.ADD_ACTIVITIES:
            return karmaActivityAdapter.addMany(action.activities, state);

        case actions.karmaActivityActionTypes.UPSERT_ACTIVITY:
            return karmaActivityAdapter.upsertOne(action.activity, state);

        case actions.karmaActivityActionTypes.UPSERT_ACTIVITIES:
            return karmaActivityAdapter.upsertMany(action.activities, state);

        case actions.karmaActivityActionTypes.UPDATE_ACTIVITY:
            return karmaActivityAdapter.updateOne(action.activity, state);

        case actions.karmaActivityActionTypes.UPDATE_ACTIVITIES:
            return karmaActivityAdapter.updateMany(action.activities, state);

        case actions.karmaActivityActionTypes.DELETE_ACTIVITY:
            // if(state.selectedGTaskId == action.id){
            //   state.selectedGTaskId = undefined;
            // }
            return karmaActivityAdapter.removeOne(action.id, state);

        case actions.karmaActivityActionTypes.DELETE_ACTIVITIES:
            // if(action.ids.indexOf(state.selectedGTaskId) > -1){
            //   state.selectedGTaskId = undefined;
            // }
            return karmaActivityAdapter.removeMany(action.ids, state);

        case actions.karmaActivityActionTypes.DELETE_ALL_ACTIVITIES:
            return karmaActivityAdapter.removeMany(action.ids, state);

        case actions.karmaActivityActionTypes.DELETE_ALL:
            return karmaActivityAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getkarmaActivityState = createFeatureSelector<karmaActivityState>('karmaActivity');

export const { selectIds, selectEntities, selectAll, selectTotal } = karmaActivityAdapter.getSelectors(getkarmaActivityState);
